// ui/components/semantic-ui/js/components/chatbot/components/message-store-context.jsx
import React, { createContext, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";

const MessageStoreContext = createContext();

export const MessageStoreProvider = ({ children, initMessage }) => {
  const [messages, setMessages] = useState(() => {
    const savedMessages = sessionStorage.getItem("chatbotMessages");
    return savedMessages
      ? JSON.parse(savedMessages)
      : [
          {
            role: "assistant",
            content: initMessage,
          },
        ];
  });

  useEffect(() => {
    sessionStorage.setItem("chatbotMessages", JSON.stringify(messages));
  }, [messages]);

  useEffect(() => {
    if (areMessagesEmpty()) {
      clearMessages();
    }
  }, [initMessage]);

  const areMessagesEmpty = () => {
    return messages.length === 1;
  };

  const addMessage = (message) => {
    setMessages((prevMessages) => [...prevMessages, message]);
  };

  const updateLastAssistantMessage = (content) => {
    setMessages((prevMessages) => {
      const idx = [...prevMessages]
        .reverse()
        .findIndex((m) => m.role === "assistant");
      if (idx === -1) return prevMessages;
      const realIdx = prevMessages.length - 1 - idx;
      const updated = [...prevMessages];
      updated[realIdx] = { ...updated[realIdx], content };
      return updated;
    });
  };

  const removeLastAssistantMessage = () => {
    setMessages((prevMessages) => {
      const idx = [...prevMessages]
        .reverse()
        .findIndex((m) => m.role === "assistant");
      if (idx === -1) return prevMessages;
      const realIdx = prevMessages.length - 1 - idx;
      return prevMessages.filter((_, i) => i !== realIdx);
    });
  };

  const clearMessages = () => {
    setMessages([
      {
        role: "assistant",
        content: initMessage,
      },
    ]);
  };

  return (
    <MessageStoreContext.Provider
      value={{
        messages,
        setMessages,
        addMessage,
        clearMessages,
        updateLastAssistantMessage,
        removeLastAssistantMessage,
      }}
    >
      {children}
    </MessageStoreContext.Provider>
  );
};

MessageStoreProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useMessageStore = () => useContext(MessageStoreContext);
